import React from 'react';
import { Layout } from '../components/Layout';

export const Order = () => {
  return (
    <Layout title="🛵 Order" subtitle="Pilih layanan">
      <div className="tg-card">
        <div className="tg-card-title">Pilih Harga:</div>
        <div className="tg-price-grid">
          {[7000, 9000, 11000, 13000, 15000, 17000, 20000, 25000, 30000, 40000, 50000, 60000, 70000, 80000].map(price => (
            <button key={price} className="tg-price-btn">Rp {price.toLocaleString()}</button>
          ))}
          <button className="tg-price-btn" style={{ gridColumn: '1 / -1', borderStyle: 'dashed' }}>✏️ Manual</button>
        </div>
        <button className="tg-btn tg-btn-primary" style={{ marginTop: '16px' }}>Pesan Sekarang</button>
      </div>
    </Layout>
  );
};
